function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.9082 14.025C14.3207 13.6448 14.5832 13.1042 14.5832 12.499C14.5832 11.35 13.6499 10.4156 12.4999 10.4156C11.3478 10.4156 10.4165 11.35 10.4165 12.499C10.4165 13.1031 10.679 13.6448 11.0915 14.025L6.35924 23.4917C6.19883 23.8136 6.21445 24.1979 6.40508 24.5052C6.5957 24.8125 6.93008 24.999 7.29154 24.999H17.7082C18.0697 24.999 18.404 24.8115 18.5947 24.5042C18.7853 24.1969 18.8009 23.8136 18.6405 23.4907L13.9082 14.025ZM13.9395 18.749H11.0603L12.4999 15.8709L13.9395 18.749ZM8.97695 22.9157L10.0186 20.8323H14.9811L16.0228 22.9157H8.97695Z",
  fill: "#EFEFEF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.3385 3.66146C18.9781 1.3 15.8385 0 12.5 0C9.16146 0 6.02187 1.3 3.66146 3.66146C1.3 6.02187 0 9.16041 0 12.499C0 15.8375 1.3 18.9771 3.66146 21.3385L5.13437 19.8656C3.16667 17.899 2.08333 15.2812 2.08333 12.499C2.08333 9.71562 3.16667 7.10104 5.13437 5.13437C7.10208 3.16667 9.71771 2.08229 12.5 2.08229C15.2823 2.08229 17.8979 3.16562 19.8656 5.13437C21.8333 7.10208 22.9167 9.71666 22.9167 12.499C22.9167 15.2812 21.8333 17.8969 19.8656 19.8635L21.3385 21.3365C23.7 18.9771 25 15.8385 25 12.499C25 9.15937 23.7 6.02187 21.3385 3.66146Z",
  fill: "#EFEFEF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.4999 5.20837C8.48013 5.20837 5.20825 8.47921 5.20825 12.5C5.20825 13.4282 5.38534 14.3396 5.73325 15.2084L7.66763 14.4313C7.41763 13.8094 7.29159 13.1605 7.29159 12.499C7.29159 9.62608 9.62804 7.29067 12.4999 7.29067C15.3718 7.29067 17.7083 9.62608 17.7083 12.499C17.7083 13.1605 17.5822 13.8105 17.3343 14.4302L19.2666 15.2073C19.6145 14.3386 19.7916 13.4282 19.7916 12.499C19.7916 8.47817 16.5197 5.20837 12.4999 5.20837Z",
  fill: "#EFEFEF"
});

var SvgSignalsIcon = function SvgSignalsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignalsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signals-icon.75411632.svg";
export { ForwardRef as ReactComponent };